import { render, staticRenderFns } from "./AanagraficaQuickConnextBox.vue?vue&type=template&id=8bb0b230&"
import script from "./AanagraficaQuickConnextBox.vue?vue&type=script&lang=js&"
export * from "./AanagraficaQuickConnextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports